<template>
    <AdmPanel :loading="loader[COMPANY+'fetch']">
        <h2 slot="header_title">一级指标得分</h2>
        <!-- <ul slot="tabs" class="adm-tabs">
            <router-link tag="li" active-class="active" :to="{name:`${isAudit?'audit_':''}result_ranking`}">排行榜</router-link>
            <router-link tag="li" active-class="active" :to="{name:`${isAudit?'audit_':''}result_firstTarget`}">一级指标得分</router-link>
        </ul> -->
        <!-- <iv-button
          v-if="isAudit"
          slot="header_buttons"
          type="primary"
          ghost
          @click="modal.release.shown=true"
        >
          <iv-icon type="md-checkbox-outline" size="14" />
          <span> 发布榜单结果</span>
        </iv-button> -->
        <div class="adm-flex-group" style="justify-content: space-between;">
          <CheckedList
            labelWidth="5em"
            title="年份："
            :sources="options.year"
            :checked="conditions.year"
            :maximun='1'
            :hasCleanButton="false"
            :loading="loader[TARGET_DATA+'fetch']"
            @changed="changeQuery(mergeQuery({year:$event,  offset:0}))"
            style="margin-top:0"/>
          <div class="ui-unshrink">
            <!-- 导出 -->
            <iv-button
              v-rbac-allow="['targetData','export']"
              :loading="loader[TARGET_DATA+'export']"
              class="export-excel-btn"
              @click="exportExcel()"
            >
              <iv-icon type="ios-cloud-download" size="14" />
              <span> 导出</span>
            </iv-button>
          </div>
        </div>
        <CheckedList
          labelWidth="5em"
          title="行业："
          :sources="industries"
          :checked="conditions.industryId"
          :maximun='1'
          :hasCleanButton="false"
          :loading="loader[TARGET_DATA+'fetch']"
          @changed="changeQuery(mergeQuery({industryId:$event, stockCode: '', offset:0}))"
          style="margin-top:0"/>
        <div class="filter-wrapper">
          <div class="adm-panel__tools checked-list">
              <span class="checked-list__title" style="width:5em;text-align: right;">公司：</span>
              <iv-select
                  style="width:150px"
                  :value="conditions.stockCode"
                  filterable
                  clearable
                  :placeholder="'企业名称/股票号'"
                  @on-change="changeQuery(mergeQuery({stockCode:$event, offset:0}))"
              >
                  <iv-option v-for="item in options.companys" :value="item.stockCode" :label="item.abbreviation" :key="item.stockCode">{{ item.abbreviation }}</iv-option>
              </iv-select>
          </div>
        </div>
        <iv-table
                class="adm-table"
                :columns="columns"
                :loading="loader[TARGET_DATA+'fetch']"
                @on-sort-change="ordering"
                :data="list.data">
        </iv-table>
        <template v-if="list.last_page > 1">
            <div slot="footer" class="pull-right">
                <iv-page
                        @on-change="pageChanged"
                        :current="list.current_page"
                        :page-size="10"
                        show-elevator
                        show-total
                        :total="list.total">
                </iv-page>
            </div>
        </template>
        <iv-modal
          :mask-closable="false"
          title="发布榜单结果"
          width="450"
          :closable="false"
          v-model="modal.release.shown"
          @on-cancel="modal.release.shown = false">
          <iv-form label-position="left" :label-width="80">
              <iv-form-item label="榜单项目年" prop="year">
                  <iv-select v-model="modal.release.data.year">
                    <iv-option
                      v-for="year in options.year"
                      :key="year.id"
                      :value="year.id"
                      >{{ year.title }}</iv-option>
                  </iv-select>
              </iv-form-item>
          </iv-form>
          <iv-alert show-icon>系统将发布上述项目年的已审核数据到外部展示平台，请认真确认数据无误后再进行发布操作</iv-alert>
          <iv-button type="text" size="large" slot="footer" @click="modal.release.shown = false;modal.release.data.year=conditions.year">取消</iv-button>
          <iv-button type="primary" size="large" slot="footer" @click="publish(modal.release.data.year)">发布</iv-button>
        </iv-modal>
    </AdmPanel>
</template>
<script>
import { RELEASE_TASKS,RELEASE_ADD_POLLING_TASK } from "@/stores/modules/release"
import { mapActions, mapGetters } from 'vuex';

import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";

import contact from "@/utils/contact";
import { conditioner, defaultVal, unique, years, downloadByUrl } from '@/utils/';

import FilterBar from "@/components/FilterBar_X2";
import CheckedList from "@/components/CheckedList";
import IndustryModel from "@/models/IndustryModel";
import CompanyModel    from '@/models/CompanyModel'
import TargetDataModel    from '@/models/TargetDataModel'
import ReleaseModel    from '@/models/ReleaseModel'

const _years = years().map(year=>({...year, title:year.name}))
const options = {
    statistics:[
      {id : '0', title: '全部数据'},
      {id : '1', title: '已审核且通过数据'},
    ]
}
const filter_rules = [
    {name: 'statistics', type: "Select", options: options.statistics, title: '统计范围', default: "", placeholder: "统计范围",style: { width: "140px" }},
]
const _conditioner = conditioner(
    {//ui到url
      limit           : {type: Number, default: 10},
      year            : {type: val=> val[0] , default: ""},
      industryId      : {type: val=> val[0] , default: ""},
      stockCode       : {type: String , default: ""},
      ordering        : {type: String, default: '' },
      statistics      : {type: String , default: ""},
    },
    {//url到ui
      limit           : {type: Number, default: 10},
      year            : {type: val=> [parseInt(val)] , default: ()=>[_years[0].id]},
      industryId      : {type: val=>  [parseInt(val)] , default: ()=>[]},
      stockCode       : {type: String, default: ""},
      ordering        : {type: String, default: '' },
      statistics      : {type: String , default: ""},
    }
)
function columns(vm){
  return  [
      {
          title: "公司名称",
          key: "abbreviation",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }

      },
      {
          title: "责任治理",
          key: "GO",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "经济",
          key: "EC",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "公平运营",
          key: "JU",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "公平运营扣分",
          key: "SE_JU",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "产品与服务",
          key: "PR",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "产品与服务扣分",
          key: "SE_PR",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "环境保护",
          key: "EN",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "环境保护扣分",
          key: "SE_EN",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "社区",
          key: "CO",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "社区扣分",
          key: "SE_CO",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "员工和安全",
          key: "EM",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "员工和安全扣分",
          key: "SE_EM",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "总分",
          key: "score",
          align: "center",
          minWidth: 100,
          sortable: true,
          sortMethod:function(a,b,type){
          }
      },
      {
          title: "去年总分",
          key: "lastScore",
          align: "center",
          minWidth: 100
      },
  ]
}

const COMPANY = CompanyModel.ModelName;
const TARGET_DATA = TargetDataModel.ModelName
const INDUSTRY = IndustryModel.ModelName
const RELEASE = ReleaseModel.ModelName

export default {
        name: "public_sentiment",
        mixins:[
            LoaderMixin(COMPANY, TARGET_DATA, TARGET_DATA+'fetch', TARGET_DATA+'export',INDUSTRY),
            ModelMixin({
                contact,
                models:[
                    TargetDataModel,
                    CompanyModel,
                    IndustryModel,
                    ReleaseModel
                ]
            })
        ],
        data() {
            return {
                TARGET_DATA,
                COMPANY,
                columns: columns(this),
                conditions: {
                  ..._conditioner.default(),
                  year: [_years[0].id]
                },
                INDUSTRY,
                list: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                options: {
                    companys: [],
                    industryId: 1,
                    year: _years,
                    industry:[],
                    stockCode: '',
                    ...options,
                    filter_rules
                },
                secondTarget:'',
                industries:[],
                sources:{
                    loading:false,
                    companyFake:''
                },
                modal: {
                  release: {
                    shown: false,
                    data: {
                      year: ""
                    }
                  }
                }
            }
        },
        async mounted () {
            const { query, params } = this.$route
            let conditions = _conditioner.serialize({...query,...params}) //处理成支持UI的格式
            let parse_conditions = _conditioner.parse(conditions)
            await this.refreshIndustry(parse_conditions.year)
            const industryId = this.industries[0].id
            if(conditions.industryId.length <= 0) conditions.industryId = [industryId]
            conditions.statistics =conditions.statistics ? conditions.statistics : (this.isAudit ? '1': '0')
            this.conditions = conditions
            await this.refreshCompanys(conditions.industryId)
            this.$nextTick(()=>{
                this.refresh(conditions)
            })
        },
        beforeRouteUpdate(to, from, next){
            this.$nextTick(async ()=>{
              const { query, params } = to
              let conditions = {
                ..._conditioner.default(),
                ..._conditioner.serialize({...query,...params}) //处理成支持UI的格式
              }
              let parse_conditions = _conditioner.parse(conditions)
              await this.refreshIndustry(parse_conditions.year)
              const industryId = this.industries[0].id
              if(conditions.industryId.length <= 0 ) conditions.industryId=[industryId]
              else if(!(this.industries.some(item => item.id === parse_conditions.industryId))) conditions.industryId=[industryId]
              conditions.statistics =conditions.statistics ? conditions.statistics : (this.isAudit ? '1': '0')
              this.conditions = conditions
              await this.refreshCompanys(conditions.industryId)
              this.refresh()
            })
            next();
        },
        methods: {
            ...mapActions([RELEASE_ADD_POLLING_TASK]),
            async refresh(query=this.conditions){
                this.list = await this.$$active(TARGET_DATA, 'firstTarget' , _conditioner.parse(query));
                this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
                this.list.last_page = this.list.total / _conditioner.parse(query).limit
            },
            async refreshCompanys(industryList){
                const res = await this.$$fetch(COMPANY, {industryList : JSON.stringify(industryList), allTab: 1})
                this.options.companys = res.data
            },
            async refreshIndustry(year){
                const industry = await this.$$fetch(INDUSTRY, {year:year})
                this.industries = industry.data.map(item=>({...item, title: item.industry }))
            },
            pageChanged(page){
                this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: ( page - 1 ) *  _conditioner.parse(this.conditions).limit}, params: this.$route.params });
            },
            mergeQuery(query){
              return { ...this.conditions, ...query}
            },
            changeQuery(query=this.conditions, params = this.$route.params) {
                this.$router.push({
                    name  : this.$route.name,
                    query: {..._conditioner.parse(query)},
                    params: params
                });
            },
            removeConditioner(fieldName, removeItem, keyField="id"){
              const list = this.conditions.stockCodeList
              const index = list.findIndex(item=>item[keyField]==removeItem[keyField])
              list.splice(index,1)
              this.conditions.stockCodeList = list
            },
            parseQuery(params, filter=[]){
              const { company } = { ...params }
              const query = {
                stockCodeList: company.map(item=>item.stockCode),
              }
              return Object.keys(query).filter(key=>filter.indexOf(key)).reduce((result, key)=>({ ...result, [key]:query[key] }),{})
            },
            async exportExcel(query = this.conditions) {
              // TODO:
              // console.log("exportExcel...", this.conditions)
              // const res = await exportFirstTargetExcel({..._conditioner.parse(this.conditions)})
              const res = await this.$$active(TARGET_DATA, 'export', {..._conditioner.parse(this.conditions), type:'firstTarget'})
              if(!res.data.url) {
                this.$$info('后台未返回url，请重试')
                return
              }
              // 下载链接
              downloadByUrl(res.data.url)
            },
            ordering(val){
              this.conditions.ordering = val.order == 'normal' ? '' : (val.order == 'asc' ? val.key : `-${val.key}`)
              this.changeQuery()
            },
            publish(year){
              this
                .$$active(RELEASE, 'publish', { type: 'csr', year })
                .then(res=>{
                  const { id } = res.data
                  this[RELEASE_ADD_POLLING_TASK](id)
                  this.modal.release.shown = false
                })
            }
        },
        watch:{
            ["conditions.year"](val){
              this.modal.release.data.year=val
            }
        },
        computed: {
          ...mapGetters([RELEASE_TASKS]),
          isAudit(){
            return this.$route.matched.some(item=>item.name=='audit')
          }
        },
        components:{
            FilterBar,
            CheckedList
        }
    }
</script>
<style lang="scss" scoped>
.checked-list{
  margin-top:20px;
  display:flex;
  align-items: baseline;
  @media screen and (min-width: 768px) {
    display: flex;
  }
  &__title{
    flex-shrink: 0;
    margin-right: 5px;
    margin-bottom: 10px;
    display: block;
    @media screen and (min-width: 768px) {
      text-align: right;
    }
  }
  &__body{
    flex-grow: 1;
    > * {
      margin-bottom: 5px;
    }
  }
}
.filter-wrapper {
  position: relative;
  .export-excel-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
